(function() { window.GUID_fe860afe_936f_45c0_8198_eb5bd6bf13d0 = { getGuid: function() { return "fe860afe-936f-45c0-8198-eb5bd6bf13d0"; } }; })();
//namespace CS {
//    export class Lazyloader implements Lazyloader.ILazyloader {
//        //#region "Properties"
//        private url: string;
//        public get Url(): string {
//            return this.url;
//        }
//        private ajaxData = {};
//        public get AjaxData(): object {
//            return this.ajaxData;
//        }
//        private itemsClass: string;
//        public get ItemsClass(): string {
//            return this.itemsClass;
//        }
//        private getQuantity: number;
//        public get GetQuantity(): number {
//            return this.getQuantity;
//        }
//        private skipQuantity = 0;
//        public get SkipQuantity(): number {
//            return this.skipQuantity;
//        }
//        private $container: JQuery;
//        public get $Container(): JQuery {
//            return this.$container;
//        }
//        private $scrollingContainer: JQuery;
//        public get $ScrollingContainer(): JQuery {
//            if (this.$scrollingContainer == null) {
//                return $(document);
//            }
//            else {
//                return this.$scrollingContainer;
//            }
//        }
//        private $skeletonUI: JQuery;
//        public get $SkeletonUI(): JQuery {
//            return this.$skeletonUI;
//        }
//        private $initialSkeletonUI: JQuery;
//        public get $InitialSkeletonUI(): JQuery {
//            return this.$initialSkeletonUI;
//        }
//        private $triggerElement = $(`<span style="display: none;"></span>`);
//        public get $TriggerElement(): JQuery {
//            return this.$triggerElement;
//        }
//        private triggerOffset: number;
//        public get TriggerOffset(): number {
//            return this.triggerOffset;
//        }
//        private isStarted = false;
//        public get IsStarted(): boolean {
//            return this.isStarted;
//        }
//        private isPaused = false;
//        public get IsPaused(): boolean {
//            return this.isPaused;
//        }
//        private isStopped = false;
//        public get IsStopped(): boolean {
//            return this.isStopped;
//        }
//        private ajaxCallsCounter = 0;
//        private itemsCounter = 0;
//        private infiniteLoad = false;
//        private debug: boolean;
//        public get Debug(): boolean {
//            return this.debug;
//        }
//        private debugSkeleton: boolean;
//        public get DebugSkeleton(): boolean {
//            return this.debugSkeleton;
//        }
//        private debugScrolling: boolean;
//        public get DebugScrolling(): boolean {
//            return this.debugScrolling;
//        }
//        private onStart: () => void;
//        public get OnStart(): () => void {
//            return this.onStart;
//        }
//        private onItemsLoaded: (response: string) => void;
//        public get OnItemsLoaded(): (response: string) => void {
//            return this.onItemsLoaded;
//        }
//        private onFirstItemsLoaded: () => void;
//        public get OnFirstItemsLoaded(): () => void {
//            return this.onFirstItemsLoaded;
//        }
//        private onPause: () => void;
//        public get OnPause(): () => void {
//            return this.onPause;
//        }
//        private onResume: () => void;
//        public get OnResume(): () => void {
//            return this.onResume;
//        }
//        private onStop: () => void;
//        public get OnStop(): () => void {
//            return this.onStop;
//        }
//        //#endregion "Properties"
//        constructor(params: Lazyloader.IParameters) {
//            const me = this;
//            if (params.debugSkeleton != null) {
//                me.debugSkeleton = params.debugSkeleton;
//            }
//            if (params.$skeletonUI != null && params.$skeletonUI.length > 0) {
//                me.$skeletonUI = params.$skeletonUI;
//            }
//            if (params.$initialSkeletonUI != null && params.$initialSkeletonUI.length > 0) {
//                me.$initialSkeletonUI = params.$initialSkeletonUI;
//            }
//            if (params.$scrollingContainer != null && params.$scrollingContainer.length > 0) {
//                me.$scrollingContainer = params.$scrollingContainer;
//            }
//            else {
//                me.$scrollingContainer = $(document);
//            }
//            if (params.ajaxData != null) {
//                me.ajaxData = params.ajaxData;
//            }
//            if (params.OnStart != null) {
//                me.onStart = params.OnStart;
//            }
//            if (params.OnPause != null) {
//                me.onPause = params.OnPause;
//            }
//            if (params.OnResume != null) {
//                me.onResume = params.OnResume;
//            }
//            if (params.OnStop != null) {
//                me.onStop = params.OnStop;
//            }
//            if (params.OnItemsLoaded != null) {
//                me.onItemsLoaded = params.OnItemsLoaded;
//            }
//            if (params.OnFirstItemsLoaded != null) {
//                me.onFirstItemsLoaded = params.OnFirstItemsLoaded;
//            }
//            if (params.infiniteLoad != null) {
//                me.infiniteLoad = params.infiniteLoad;
//            }
//            me.url = params.url;
//            me.itemsClass = params.itemsClass;
//            me.getQuantity = params.getQuantity;
//            me.triggerOffset = (params.triggerOffset != undefined && !isNaN(params.triggerOffset)) ? params.triggerOffset : 0;
//            me.$container = params.$container;
//            me.$triggerElement.attr("id", `${params.itemsClass}-lazyloader-trigger`);
//            me.debug = params.debug;
//            me.debugSkeleton = params.debugSkeleton;
//            me.debugScrolling = params.debugScrolling;
//            if (!CommonData.Current.IsDebug()) {
//                me.debug = false;
//                me.debugSkeleton = false;
//                me.debugScrolling = false;
//            }
//        }
//        public Start() {
//            const me = this;
//            if (!me.IsStarted) {
//                if (!me.IsPaused) {
//                    me.isStarted = true;
//                    if (me.infiniteLoad !== true) {
//                        me.skipQuantity = me.$container.find(`.${me.ItemsClass}:not(.skeleton)`).length;
//                    }
//                    if (me.Debug) {
//                    }
//                    if (!me.DebugSkeleton) {
//                        me.GetElements();
//                    }
//                }
//            }
//        }
//        public Pause() {
//            const me = this;
//            if (me.IsStarted) {
//                if (!me.IsStopped) {
//                    me.isPaused = true;
//                    me.UnbindScrollEvent();
//                    if (me.Debug) {
//                        console.info("Lazyloader paused");
//                    }
//                }
//            }
//        }
//        public Resume() {
//            const me = this;
//            if (me.IsStarted) {
//                if (!me.IsStopped) {
//                    if (me.IsPaused) {
//                        me.BindScrollEvent();
//                        me.isPaused = false;
//                        if (me.Debug) {
//                            console.info("Lazyloader resumed");
//                        }
//                    }
//                }
//            }
//        }
//        public Stop() {
//            const me = this;
//            if (me.IsStarted) {
//                if (!me.IsStopped) {
//                    me.isStopped = true;
//                    me.UnbindScrollEvent();
//                    me.$TriggerElement.remove();
//                    if (me.$SkeletonUI != undefined) {
//                        me.$SkeletonUI.remove();
//                    }
//                    if (me.Debug) {
//                        console.info("Lazyloader stopped");
//                    }
//                    if (me.OnStop != null) {
//                        me.OnStop.call(me);
//                    }
//                }
//            }
//        }
//        public Restart() {
//            const me = this;
//            if (me.IsStarted) {
//                if (me.IsStopped) {
//                    me.isStopped = false;
//                    if (me.infiniteLoad !== true) {
//                        me.skipQuantity = me.$container.find(`.${me.ItemsClass}:not(.skeleton)`).length;
//                    }
//                    me.GetElements();
//                }
//            }
//        }
//        public Dispose() {
//            const me = this;
//            me.Stop();
//        }
//        private BindScrollEvent() {
//            let me = this;
//            me.$Container.append(me.$skeletonUI);
//            me.$Container.append(me.$triggerElement);
//            let triggerElementHeight = me.$triggerElement.outerHeight(),
//                skeletonElementHeight = (me.$skeletonUI != undefined && me.$skeletonUI.length > 0) ? me.$skeletonUI.outerHeight() : 0,
//                windowHeight = $(window).height(),
//                scrollingContainerHeight = me.$Container.height(),
//                triggerEventScrollTop = scrollingContainerHeight + triggerElementHeight - me.TriggerOffset - skeletonElementHeight;
//            if (me.DebugScrolling) {
//                console.info("me.$Container", me.$Container);
//                console.info("me.$TriggerElement", me.$TriggerElement);
//                console.info("scrollingContainerHeight", scrollingContainerHeight);
//                console.info("triggerElementHeight", triggerElementHeight);
//                console.info("skeletonElementHeight", skeletonElementHeight);
//                console.info("windowHeight", windowHeight);
//                console.info("triggerEventScrollTop", triggerEventScrollTop);
//            }
//            let i = 0;
//            me.$ScrollingContainer.bind(`scroll.lazyloader-${me.ItemsClass}`, function () {
//                let triggerElementScrollTop = $(this).scrollTop(),
//                    currentScrollTop = triggerElementScrollTop + windowHeight;
//                if (me.Debug) {
//                    if (i % 10 == 0) {
//                        console.info("currentScrollTop", currentScrollTop);
//                    }
//                    i++;
//                }
//                if (currentScrollTop >= triggerEventScrollTop) {
//                    me.UnbindScrollEvent();
//                    if (!me.IsPaused) {
//                        me.GetElements();
//                    }
//                }
//            });
//            if (me.Debug) {
//                console.info(`Lazyloader scroll event binded`);
//            }
//        }
//        private UnbindScrollEvent() {
//            const me = this;
//            me.$ScrollingContainer.off(`scroll.lazyloader-${me.ItemsClass}`);
//            if (me.Debug) {
//                console.info(`Lazyloader scroll event unbinded`);
//            }
//        }
//        private GetElements() {
//            const me = this;
//            let data = me.AjaxData;
//            data["getQuantity"] = me.GetQuantity;
//            data["skipQuantity"] = me.SkipQuantity;
//            if (me.Debug) {
//                console.info(`Loading "${this.itemsClass}" elements...`);
//            }
//            if (this.LazyloadingDataIsValid()) {
//                CS.Ajax.Get(me.Url, data, function (response) {
//                    let $response = $(response),
//                        responseElementsCounter = 0;
//                    if (me.Debug) {
//                        console.groupCollapsed("Lazyloader response", me);
//                        console.info(response);
//                        console.groupEnd();
//                    }
//                    if (me.ajaxCallsCounter == 0) {
//                        if (me.$SkeletonUI != null) {
//                            me.$SkeletonUI.remove();
//                        }
//                        if (me.$InitialSkeletonUI != null) {
//                            me.$InitialSkeletonUI.remove();
//                        }
//                    }
//                    me.$TriggerElement.remove();
//                    if ($response.length > 0) {
//                        for (var i = 0; i < $response.length; i++) {
//                            let $element = $($response[i]);
//                            if ($element.hasClass(me.itemsClass)) {
//                                if (me.infiniteLoad !== true) {
//                                    me.skipQuantity++;
//                                }
//                                me.itemsCounter++;
//                                responseElementsCounter++;
//                            }
//                        }
//                        if (me.OnItemsLoaded != null) {
//                            me.OnItemsLoaded.call(me, response);
//                        }
//                        if (me.ajaxCallsCounter == 0) {
//                            if (me.OnFirstItemsLoaded != null) {
//                                me.OnFirstItemsLoaded.call(me);
//                            }
//                        }
//                        if (responseElementsCounter >= me.GetQuantity || me.infiniteLoad === true) {
//                            me.BindScrollEvent();
//                        }
//                        else if (me.$SkeletonUI != null) {
//                            me.Stop();
//                        }
//                    }
//                    else if (me.$skeletonUI != undefined) {
//                        me.$skeletonUI.remove();
//                    }
//                    me.ajaxCallsCounter++;
//                }, (extraParams) => {
//                    extraParams.showTopBuzyIndicator= false;
//                });
//            }
//        }
//        private LazyloadingDataIsValid() {
//            const me = this;
//            return me.Url != null && me.GetQuantity != null && me.SkipQuantity != null;
//        }
//    }
//    export namespace Lazyloader {
//        export interface ILazyloader {
//            Url: string;
//            AjaxData: object;
//            ItemsClass: string;
//            GetQuantity: number;
//            SkipQuantity: number;
//            $Container: JQuery;
//            $ScrollingContainer: JQuery;
//            $SkeletonUI: JQuery;
//            $InitialSkeletonUI: JQuery;
//            $TriggerElement: JQuery;
//            TriggerOffset: number;
//            IsStarted: boolean;
//            IsPaused: boolean;
//            IsStopped: boolean;
//            Debug: boolean;
//            DebugSkeleton: boolean;
//            Start: () => void;
//            Pause: () => void;
//            Resume: () => void;
//            Stop: () => void;
//            Restart: () => void;
//            Dispose: () => void;
//        }
//        export interface IParameters {
//            url: string;
//            /** The number of items to load per call. */
//            getQuantity: number;
//            /** Extra data to include in the ajax call. Do NOT include "getQuantity" or "skipQuantity" in this object as they are automatically included by the Lazyloader instance. */
//            ajaxData?: object;
//            /** Used to identify and count loaded elements. */
//            itemsClass: string;
//            /** Loaded elements are appended to this element. */
//            $container: JQuery;
//            /** Scroll event is attached to this element. */
//            $scrollingContainer?: JQuery;
//            /** Offsets the position of the scroll event trigger. */
//            triggerOffset?: number;
//            /** Appended to "$container" when items are loading and removed when items are loaded. */
//            $skeletonUI?: JQuery;
//            /** If included, this element is removed when the first batch of items is loaded. */
//            $initialSkeletonUI?: JQuery;
//            /** If true, logs basic data (event binding, ajax response...). */
//            debug?: boolean;
//            /** If true, displays skeleton UI and prevents items loading. */
//            debugSkeleton?: boolean;
//            /** If true, logs scrolling position and height of elements used to calculate scroll event. */
//            debugScrolling?: boolean;
//            /** If true, Lazyloader will not stop by itself. */
//            infiniteLoad?: boolean;
//            OnStart?: () => void;
//            OnItemsLoaded: (response: string) => void;
//            /** Called immediately after "OnItemsLoaded". */
//            OnFirstItemsLoaded?: () => void;
//            OnPause?: () => void;
//            OnResume?: () => void;
//            OnStop?: () => void;
//        }
//    }
//}

//# sourceMappingURL=cs-lazyloader.js.map
